import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IPlanItem {
  readonly _id: string;
  readonly title: string;
  readonly siteName?: string;
}

export interface IPlanSelector {
  readonly id: string;
  readonly type: MESSAGES.PLAN_SELECTOR;
  readonly items: IPlanItem[];
  readonly nodeId: string;
  readonly pageSize: number;
  readonly rm: boolean;
  readonly role?: string;
}

export const createPlanSelector = (data): IPlanSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.PLAN_SELECTOR,
  items: data.items,
  nodeId: data.nodeId,
  pageSize: data.pageSize,
  rm: Boolean(data.rm),
});
